import { errorToast, type ErrorToast } from "@/shared/lib/apiErrors";

/**
 * V26 (2026-05-14) Wave 4.6 — 海报提交错误分类 toast。
 *
 * 0926 修复波 E:码表并进全站统一的 `apiErrors.ts`(117 个后端码全配中文标题,快照守卫),
 * 本文件只留老名字给既有调用点。未知码标题不再是「请求失败 (XXX_CODE)」,而是「操作没有成功」,
 * 码与排查号放在描述末行。
 */
export type PosterErrorToast = ErrorToast;

export function posterErrorToast(e: unknown): PosterErrorToast {
  return errorToast(e);
}
